<template>
    <!--<div class="my-bscroll-wrapper" ref="my_bscroll_wrapper">-->
        <!--<div class="my-bscroll-content">-->
          <div>
            <slot></slot>
          </div>
        <!--</div>-->
    <!--</div>-->
</template>

<script>
import BScroll from 'better-scroll'
export default {
    props: {
        // https://ustbhuangyi.github.io/better-scroll/doc/zh-hans/options-advanced.html#scrollbar
    },
    data: function () {
        return {}
    },
    methods: {
        _initScroll: function () {
            if (!this.$refs.my_bscroll_wrapper) {
                return
            }
            this.scroll = new BScroll(this.$refs.my_bscroll_wrapper, {
                scrollX: true,
                scrollY: true,
                mouseWheel: true, // 鼠标滚轮
                bounce: false,    // 回弹
                scrollbar: {      // 滚动条
                    fade: true,
                    interactive: true
                }
            })
        },
        refresh: function () {
            // 代理better-scroll的refresh方法
            this.scroll && this.scroll.refresh()
        }
    },
    watch: {
        // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
        data: function () {
            let self = this
            setTimeout(function () {
                self.refresh()
            }, 20)
        }
    },
    mounted: function () {
        // 保证在DOM渲染完毕后初始化better-scroll
        let self = this
        setTimeout(function () {
            self._initScroll()
        }, 20)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/my-bscroll.vue